import React from 'react';
import MasterButton from '../../general_components/MasterButton/MasterButton';
import gg_plus_logo from '../../../images/logos/gg_plus/gg_plus_103.png';
import gg_logo from '../../../images/logos/logo.png';
import monthly_gifts from '../../../images/illustrations/recurring_gift_green_bg_100.png';
import gift_matching from '../../../images/illustrations/2x gifts 100x100.png';
import momentum from '../../../images/illustrations/GG+ gifts momentum.png';
import gg_flow from '../../../images/illustrations/gg flow.png';
import gg_icon from '../../../images/logos/gg_logo_icon.png';
import './Plus_pass_offer.css';

function monthCount(months) {
  const n = Number(months);
  if (!Number.isInteger(n) || n < 1) return 3;
  return n;
}

function monthsLabel(months) {
  const n = monthCount(months);
  return n === 1 ? '1 month' : `${n} months`;
}

/** Named giver when we have one. Otherwise the pass stands on its own. */
function offerHeadline(giverLabel, months) {
  const span = monthsLabel(months);
  if (giverLabel) return `${giverLabel} gave you ${span} of GG+`;
  return `You’ve got ${span} of GG+`;
}

function readyLine(months) {
  const n = monthCount(months);
  return n === 1 ? 'Your 1 month is ready.' : `Your ${n} months are ready.`;
}

const INCLUDED = [
  {
    title: 'Greatest Gift',
    image: gg_logo,
    body: 'Create a gifting page around your child’s goals and give the people who love them a meaningful way to contribute.',
  },
  {
    title: 'Monthly Gifts',
    image: monthly_gifts,
    body: 'Let grandparents, family and friends turn one gift into ongoing support, month after month.',
  },
  {
    title: 'Gift Matching',
    image: gift_matching,
    body: 'Give people another reason to contribute and make every gift go further.',
  },
];

function ClaimButton({ onClaim }) {
  return (
    <div className="pass_offer_cta">
      <MasterButton
        buttonText="Claim your pass"
        handleButtonClick={onClaim}
        notSticky={true}
      />
    </div>
  );
}

function IntroCopy() {
  return (
    <div className="pass_offer_intro_copy">
      <img src={gg_logo} alt="Greatest Gift" className="pass_offer_intro_logo" />
      <h2>New to Greatest Gift?</h2>
      <p className="pass_offer_intro_lead">
        Build a great financial future for the kids you love.
      </p>
      <p>
        Greatest Gift turns birthdays, milestones, and everyday generosity into money for their future.
        Create a gifting page, share it with family and friends, and put gifts toward the goals that matter to you.
      </p>
    </div>
  );
}

/** Open pass landing. Shown when a pass link is ready to claim. */
function Plus_pass_offer({ durationMonths, giverLabel, onClaim }) {
  return (
    <div className="pass_offer">
      <section className="pass_offer_hero">
        <img src={gg_plus_logo} alt="GG+" className="pass_offer_logo" />
        <h1>{offerHeadline(giverLabel, durationMonths)}</h1>
        <p className="pass_offer_hero_support">
          Build a great financial future for the kids you love, with a little extra momentum.
        </p>
        <ClaimButton onClaim={onClaim} />
        <p className="pass_offer_fine">
          Normally $3–$12/month · No credit card required · Nothing automatically renews
        </p>
      </section>

      {/* How Greatest Gift works, for someone opening the product for the first time. */}
      <section className="pass_offer_intro">
        <IntroCopy />
        <img
          src={gg_flow}
          alt="A parent shares a child’s gifting page, family sends gifts, and the gifts grow"
          className="pass_offer_intro_art"
        />
      </section>

      <section className="pass_offer_included">
        <img src={gg_plus_logo} alt="" className="pass_offer_mark" />
        <h2>Build momentum for their future.</h2>
        <p className="pass_offer_section_lead">
          Your pass includes the full Greatest Gift experience, plus more ways to turn support from family and friends into progress over time.
        </p>
        <h3>What your pass gives you</h3>
        <div className="pass_offer_cards">
          {INCLUDED.map((item) => (
            <div key={item.title} className="pass_offer_card">
              {/* Same frame for the wordmark and the two badges so the row lines up. */}
              <div className="pass_offer_card_art">
                <img src={item.image} alt="" />
              </div>
              <h4>{item.title}</h4>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pass_offer_momentum">
        <div className="pass_offer_momentum_copy">
          <h2>Turn good intentions into momentum.</h2>
          <p>
            An aunt starts a monthly gift. Grandma matches contributions. Someone gives a little more because their gift will go further.
          </p>
          <p>Small actions can add up to something much bigger over time.</p>
        </div>
        <img
          src={momentum}
          alt="Family and friends sending gifts that grow into savings"
          className="pass_offer_momentum_art"
        />
      </section>

      <section className="pass_offer_line">
        <img src={gg_plus_logo} alt="" className="pass_offer_mark" />
        <p>For parents who want to be more intentional about their child’s financial future.</p>
      </section>

      <section className="pass_offer_close">
        <h2>{readyLine(durationMonths)}</h2>
        <p>Get started with Greatest Gift and everything included with your GG+ Pass.</p>
        <ClaimButton onClaim={onClaim} />
        <p className="pass_offer_fine">No credit card required · Nothing automatically renews</p>
      </section>

      {/* Same footer as the gifting flow. */}
      <div className="pass_offer_footer">
        <a href="https://www.greatestgiftapp.com" target="_blank" rel="noreferrer">
          <img src={gg_icon} alt="gg icon" />
        </a>
        <p className="tiny_text">Greatest Gift Inc.</p>
        <p className="small_text">|</p>
        <a href="/legal?active=privacy" target="_blank" className="tiny_text" rel="noreferrer">Privacy</a>
        <a href="/legal" target="_blank" rel="noreferrer" className="tiny_text">Terms</a>
        <a href="https://www.greatestgiftapp.com/#faq" target="_blank" rel="noreferrer" className="tiny_text">FAQ</a>
      </div>
    </div>
  );
}

export default Plus_pass_offer;
